<div class="min-h-screen bg-gray-50">
  <!-- Header -->
  <app-header-nav></app-header-nav>

  <!-- Once there is something in the cart, say so where it cannot be missed
       and give one tap through to checkout and payment. The only route before
       was a button in the top toolbar, which a customer reported not being
       able to find at all. -->
  <!-- z-40, BELOW the dialogs, and hidden whenever one is open.
       At z-[60] this bar floated ABOVE every overlay (they are all z-50) and
       physically covered the cart's "Proceed to Payment" button, so adding an
       item made checkout unreachable — a worse bug than the one it fixed. -->
  <!-- Hidden while ANY dialog is open, not just the cart and payment ones.
       Every dialog here is a full-screen `fixed inset-0` backdrop at z-50, so
       with one open this bar stayed on screen, dimmed, and swallowed nothing:
       a customer could see "View cart (1)" and tapping it did nothing at all,
       because the backdrop was taking the tap. Visible-but-dead is worse than
       absent. -->
  <div *ngIf="getTotalItems() > 0 && !isCartOpen && !isPaymentOpen && !isFeedbackOpen
              && !isDrinkDetailOpen && !isPaymentConfirmationOpen && !isScanningQR"
       class="fixed bottom-0 left-0 right-0 z-40 bg-indigo-700 text-white shadow-2xl">
    <button mat-button class="!w-full !justify-between !py-4 !px-5 !text-white"
            (click)="openCart()" aria-label="View your cart and check out">
      <span class="flex items-center gap-2 font-semibold">
        <mat-icon>shopping_cart</mat-icon>
        View cart ({{ getTotalItems() }})
      </span>
      <span class="flex items-center gap-2 font-semibold">
        {{ getTotalPrice() | currency }}
        <mat-icon>arrow_forward</mat-icon>
      </span>
    </button>
  </div>

  <div>
    <div class="sticky top-0 z-50 bg-white border-b shadow-sm">
      <!-- flex-wrap: this row did not wrap, so on a narrow window the Scan QR
           / Chat / Cart buttons were pushed off the right-hand edge and a
           customer could add items but never find the cart. -->
      <div class="flex flex-wrap items-center justify-between gap-2 p-4">
        <div class="flex items-center gap-3">
          <button mat-icon-button (click)="onBack()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <div>
            <h1 class="flex items-center gap-2 text-lg font-semibold">
              The Local Bar
            </h1>
            <p class="text-sm text-gray-600 flex items-center gap-1">
              <mat-icon class="text-sm">location_on</mat-icon>
              Downtown Location
              <span *ngIf="tableNumber"> • Table {{ tableNumber }}</span>
              <span *ngIf="orderType === 'takeaway'"> • Takeaway Order</span>
            </p>
          </div>
        </div>
        <div class="flex items-center gap-2">
          <button *ngIf="orderType === 'table'" mat-stroked-button (click)="openQRScanner()">
            <mat-icon>qr_code</mat-icon>
            Scan QR
          </button>
          <button *ngIf="barIdFromQuery" mat-stroked-button (click)="openBarChat()" title="Chat with the bar">
            <mat-icon>chat</mat-icon>
            Chat
          </button>
          <button mat-raised-button color="primary" (click)="openCart()" class="relative">
            <mat-icon>shopping_cart</mat-icon>
            Cart
            <span *ngIf="getTotalItems() > 0"
              class="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
              {{ getTotalItems() }}
            </span>
          </button>
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div class="flex items-center justify-center h-screen" *ngIf="isLoading">
      <mat-spinner></mat-spinner>
    </div>

    <div class="p-4 space-y-4" *ngIf="!isLoading">
      <!-- Order Type Selection -->
      <mat-card>
        <mat-card-content class="pt-6">
          <div class="flex items-center justify-center gap-4">
            <button mat-raised-button [color]="orderType === 'table' ? 'primary' : ''"
              [class.mat-outlined]="orderType !== 'table'" (click)="setOrderType('table')" class="flex-1">
              <mat-icon>restaurant</mat-icon>
              Dine In (Table Service)
            </button>
            <button mat-raised-button [color]="orderType === 'takeaway' ? 'primary' : ''"
              [class.mat-outlined]="orderType !== 'takeaway'" (click)="setOrderType('takeaway')" class="flex-1">
              <mat-icon>shopping_bag</mat-icon>
              Takeaway
            </button>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Category Tabs -->
      <mat-tab-group [(selectedIndex)]="selectedCategoryIndex" (selectedTabChange)="onCategoryChange($event)">
        <mat-tab label="All"></mat-tab>
        <mat-tab *ngFor="let category of categories" [label]="category.name"></mat-tab>
      </mat-tab-group>

      <!-- Menu Grid -->
      <div class="mt-4">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <mat-card *ngFor="let drink of getFilteredMenu(drinks$ | async)"
            class="cursor-pointer transition-all hover:shadow-lg" [class.opacity-60]="!drink.isAvailable"
            (click)="drink.isAvailable && openDrinkDetail(drink)">
            <mat-card-header class="pb-2">
              <div class="flex items-start justify-between">
                <div class="flex-1">
                  <mat-card-title class="text-lg">{{ drink.name }}</mat-card-title>
                  <div class="flex items-center gap-2 mt-1">
                    <mat-chip class="text-xs">{{ drink.categoryName }}</mat-chip>
                    <div class="flex items-center gap-1">
                      <mat-icon class="text-yellow-400 text-sm">star</mat-icon>
                      <span class="text-xs text-gray-600">{{ drink.overallRating || 'N/A' }}</span>
                    </div>
                  </div>
                </div>
                <div class="text-right ml-7">
                  <p class="text-lg font-semibold">${{ drink.price }}</p>
                  <mat-chip *ngIf="!drink.isAvailable" color="warn" class="text-xs">Unavailable</mat-chip>
                </div>
              </div>
            </mat-card-header>
            <mat-card-content>
              <p class="text-sm text-gray-600 mb-3">{{ drink.description }}</p>
              <button *ngIf="drink.isAvailable" mat-raised-button color="primary" class="w-full"
                (click)="addToCart(drink, $event)">
                <mat-icon>add</mat-icon>
                Add to Cart
              </button>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>


  <!-- QR Scanner Dialog -->
  <mat-dialog-content *ngIf="isQRScannerOpen" class="text-center space-y-4">
    <h2 mat-dialog-title>Scan Table QR Code</h2>

    <div *ngIf="!isScanningQR" class="space-y-4">
      <p mat-dialog-content>
        We need access to your camera to scan the QR code on your table.
      </p>
      <div class="w-48 h-48 mx-auto bg-gray-100 rounded-lg flex items-center justify-center">
        <mat-icon class="text-gray-400 text-6xl">camera_alt</mat-icon>
      </div>
      <p class="text-sm text-gray-600">
        Click "Allow Camera Access" when prompted by your browser
      </p>
      <button mat-raised-button color="primary" (click)="requestCameraAccess()" class="w-full">
        <mat-icon>camera_alt</mat-icon>
        Allow Camera Access
      </button>
      <!-- Replaced "Skip (Simulate Scan)", which assigned a random table
           number and no bar at all. If the camera is unavailable the customer
           can still say which table they are at. -->
      <button mat-stroked-button (click)="stopScanning()" class="w-full">
        Enter my table number instead
      </button>
    </div>

    <div *ngIf="isScanningQR" class="space-y-4">
      <p mat-dialog-content>
        Camera is active! Point your camera at the QR code on your table.
      </p>
      <!-- The live camera feed the decoder reads frames from. The old markup
           showed a pulsing icon over nothing while a timer invented a table. -->
      <div class="w-64 h-64 mx-auto rounded-lg overflow-hidden border-2 border-green-500 bg-black">
        <video #qrVideo autoplay playsinline muted class="w-full h-full object-cover"></video>
      </div>
      <p class="text-sm text-green-600">
        Scanning for QR code...
      </p>
      <div class="flex gap-2">
        <!-- stopScanning() also releases the camera; the old handler just
             hid the dialog and left the stream running. -->
        <button mat-stroked-button (click)="stopScanning()" class="flex-1">
          Cancel
        </button>
      </div>
    </div>
  </mat-dialog-content>

  <!-- Drink Detail Dialog -->
  <mat-dialog-content *ngIf="isDrinkDetailOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 shadow-lg">
    <div class="bg-white p-6 rounded-lg shadow-lg">
      <div class="flex items-center justify-between">
        <h2 class="text-xl font-semibold">Your Drink</h2>
        <button mat-icon-button (click)="isDrinkDetailOpen = false" color="warn">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <h2 mat-dialog-title>{{ selectedDrink?.name }}</h2>
      <p mat-dialog-content>
        Add this item to your cart with optional notes or special requests.
      </p>
      <div *ngIf="selectedDrink" class="space-y-4">
        <div class="flex items-center justify-between">
          <mat-chip>{{ selectedDrink.categoryName }}</mat-chip>
          <div class="flex items-center gap-1">
            <mat-icon class="text-yellow-400">star</mat-icon>
            <span>{{ selectedDrink.overallRating || 'N/A' }}</span>
          </div>
        </div>

        <p class="text-gray-600">{{ selectedDrink.description }}</p>

        <div class="text-2xl font-semibold">${{ selectedDrink.price }}</div>

        <div>
          <mat-form-field class="w-full">
            <mat-label>Special Notes (Optional)</mat-label>
            <textarea matInput placeholder="Any special requests or preferences..." rows="3"
              [(ngModel)]="itemNotes"></textarea>
          </mat-form-field>
        </div>

        <button mat-raised-button color="primary" class="w-full" (click)="addToCartWithNotes(selectedDrink, itemNotes)">
          <mat-icon>add</mat-icon>
          Add to Cart - ${{ selectedDrink.price }}
        </button>
      </div>
    </div>
  </mat-dialog-content>

  <!-- Cart Dialog -->
  <div *ngIf="isCartOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
      <div class="p-6 space-y-4">
        <div class="flex items-center justify-between">
          <h2 class="text-xl font-semibold">Your Order</h2>
          <button mat-icon-button (click)="isCartOpen = false" color="warn">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <!-- Order Summary Header -->
        <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div class="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span class="font-medium text-blue-800">Invoice #:</span>
              <span class="text-blue-600">{{ invoiceNumber }}</span>
            </div>
            <div>
              <span class="font-medium text-blue-800">Items:</span>
              <span class="text-blue-600">{{ getTotalItems() }}</span>
            </div>
            <div>
              <span class="font-medium text-blue-800">Customer:</span>
              <span class="text-blue-600">{{ customerName || 'Guest' }}</span>
            </div>
            <div>
              <span class="font-medium text-blue-800">Total:</span>
              <span class="text-blue-600 font-semibold">${{ getTotalPrice() }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="orderType === 'table' && !tableNumber" class="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
          <div class="flex items-center gap-2">
            <mat-icon class="text-yellow-600">schedule</mat-icon>
            <span class="text-sm text-yellow-800">Please scan your table QR code or enter table number</span>
          </div>
        </div>

        <mat-form-field *ngIf="orderType === 'table'" class="w-full">
          <mat-label>Table Number</mat-label>
          <input matInput [(ngModel)]="tableNumber" placeholder="Enter your table number">
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>Your Name</mat-label>
          <input matInput [(ngModel)]="customerName" placeholder="Enter your name">
        </mat-form-field>

        <div>
          <label class="text-sm font-medium">Items in Cart ({{ cart.length }} items)</label>
          <div class="h-48 border rounded-lg p-3 overflow-y-auto">
            <div *ngIf="cart.length === 0" class="text-center py-8 text-gray-600">
              <mat-icon class="text-5xl opacity-50">shopping_cart</mat-icon>
              <p>Your cart is empty</p>
              <p class="text-sm">Add some drinks to get started!</p>
            </div>
            <div *ngFor="let item of cart; let i = index"
              class="flex items-center justify-between py-2 border-b last:border-b-0">
              <div class="flex-1">
                <p class="font-medium">{{ item.drink.name }}</p>
                <p class="text-sm text-gray-600">${{ item.drink.price }} each</p>
                <p *ngIf="item.notes" class="text-xs text-blue-600">Note: {{ item.notes }}</p>
              </div>
              <div class="flex items-center gap-2">
                <button mat-icon-button (click)="updateCartQuantity(item, -1)">
                  <mat-icon>remove</mat-icon>
                </button>
                <span class="w-8 text-center font-medium">{{ item.quantity }}</span>
                <button mat-icon-button (click)="updateCartQuantity(item, 1)">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
              <div class="w-16 text-right font-semibold">
                ${{ (item.drink.price * item.quantity).toFixed(2) }}
              </div>
            </div>
          </div>
        </div>

        <mat-form-field class="w-full">
          <mat-label>Order Notes (Optional)</mat-label>
          <textarea matInput [(ngModel)]="orderNotes" placeholder="Any special requests for your order..."
            rows="2"></textarea>
        </mat-form-field>

        <div *ngIf="cart.length > 0" class="border-t pt-4">
          <div class="flex justify-between items-center text-lg">
            <span>Total:</span>
            <span>${{ getTotalPrice() }}</span>
          </div>
          <button mat-raised-button color="primary" class="w-full mt-2" (click)="placeOrder()"
            [disabled]="orderType === 'table' && !tableNumber">
            Proceed to Payment
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Payment Dialog -->
  <mat-dialog-content *ngIf="isPaymentOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg shadow-xl p-6 w-full max-w-lg mx-auto">
      <div class="flex items-center justify-between mb-4">
        <h2 mat-dialog-title class="text-xl font-semibold">Payment</h2>
        <button mat-icon-button (click)="closePayment()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="bg-gray-50 rounded-lg p-4 mb-4">
        <h3 class="text-sm font-medium text-gray-700 mb-2">Order Summary</h3>
        <div class="space-y-1">
          <div *ngFor="let item of cart" class="flex justify-between text-sm text-gray-800">
            <span>{{ item.drink.name }} x{{ item.quantity }}</span>
            <span>${{ (item.drink.price * item.quantity).toFixed(2) }}</span>
          </div>
        </div>
        <div class="border-t border-gray-200 pt-3 mt-3 flex justify-between items-center">
          <span class="text-base font-medium">Total:</span>
          <span class="text-xl font-bold text-blue-700">${{ getTotalPrice() }}</span>
        </div>
      </div>

      <div class="mb-6">
        <label class="text-sm font-medium text-gray-700 block mb-2">Payment Method</label>
        <div class="grid grid-cols-2 gap-3">
          <button mat-raised-button [color]="paymentMethod === 'CARD' ? 'primary' : ''"
            [class.mat-stroked-button]="paymentMethod !== 'CARD'" (click)="setPaymentMethod('CARD')"
            class="flex flex-col items-center justify-center py-3 px-2 text-sm">
            <mat-icon class="mb-1">credit_card</mat-icon>
            Card
          </button>
          <button mat-raised-button [color]="paymentMethod === 'CASH' ? 'primary' : ''"
            [class.mat-stroked-button]="paymentMethod !== 'CASH'" (click)="setPaymentMethod('CASH')"
            class="flex flex-col items-center justify-center py-3 px-2 text-sm">
            <span class="text-xl mb-1">💵</span>
            Cash
          </button>
          <button mat-raised-button [color]="paymentMethod === 'MOBILE' ? 'primary' : ''"
            [class.mat-stroked-button]="paymentMethod !== 'MOBILE'" (click)="setPaymentMethod('MOBILE')"
            class="flex flex-col items-center justify-center py-3 px-2 text-sm">
            <mat-icon class="mb-1">smartphone</mat-icon>
            Mobile Money
          </button>
        </div>
      </div>

      <div class="space-y-3 mb-4">
        <button mat-raised-button color="primary" (click)="processPayment()" class="w-full py-3 text-lg font-semibold">
          <mat-icon *ngIf="paymentMethod === 'CARD'" class="mr-2">credit_card</mat-icon>
          <mat-icon *ngIf="paymentMethod === 'MOBILE'" class="mr-2">smartphone</mat-icon>
          <mat-icon *ngIf="paymentMethod === 'DIGITAL'" class="mr-2">account_balance_wallet</mat-icon>
          <mat-icon *ngIf="paymentMethod === 'CASH'" class="mr-2">money</mat-icon>
          <!-- Named the provider "Stripe" for every method, including cash and
               mobile money. Say what the button does instead. -->
          {{ paymentMethod === 'CASH'
               ? 'Place Order (Pay at Counter)'
               : 'Pay $' + getTotalPrice() }}
        </button>
        <button mat-stroked-button (click)="closePayment()" class="w-full py-3 text-lg">
          Back to Cart
        </button>
      </div>

      <div *ngIf="paymentMethod !== 'CASH'" class="bg-blue-50 border border-blue-200 rounded-lg p-3">
        <div class="flex items-center gap-2">
          <mat-icon class="text-blue-600">security</mat-icon>
          <span class="text-sm text-blue-800">Secure payment powered by Stripe</span>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <!-- Payment Confirmation Dialog -->
  <mat-dialog-content *ngIf="isPaymentConfirmationOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg shadow-2xl p-6 w-full max-w-md mx-auto">
      <div class="text-center mb-6">
        <div
          class="mx-auto w-16 h-16 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center mb-4">
          <mat-icon class="text-white text-4xl">check_circle</mat-icon>
        </div>
        <h2 class="text-2xl font-bold text-gray-800">Confirm Payment</h2>
        <p class="text-sm text-gray-600 mt-2">Please verify your order details</p>
      </div>

      <!-- Order Summary Card -->
      <div class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-4 mb-4 border border-blue-200">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold text-gray-700 flex items-center gap-2">
            <mat-icon class="text-blue-600 text-lg">receipt</mat-icon>
            Summary
          </h3>
          <span class="text-xs text-gray-500">{{ invoiceNumber }}</span>
        </div>

        <div class="space-y-2 mb-3">
          <div *ngFor="let item of cart" class="flex justify-between text-sm">
            <span class="text-gray-700">{{ item.drink.name }} <span class="text-gray-500">×{{ item.quantity
                }}</span></span>
            <span class="font-medium text-gray-800">${{ (item.drink.price * item.quantity).toFixed(2) }}</span>
          </div>
        </div>

        <div class="border-t border-blue-300 pt-3 mt-3">
          <div class="flex justify-between items-center">
            <span class="text-base font-semibold text-gray-800">Total Amount</span>
            <span class="text-2xl font-bold text-blue-700">${{ getTotalPrice().toFixed(2) }}</span>
          </div>
        </div>
      </div>

      <!-- Payment Details -->
      <div class="bg-gray-50 rounded-lg p-4 mb-6 space-y-2">
        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">Payment Method:</span>
          <span class="text-sm font-semibold text-gray-800 flex items-center gap-2">
            <mat-icon *ngIf="paymentMethod === 'CARD'" class="text-blue-600 text-lg">credit_card</mat-icon>
            <mat-icon *ngIf="paymentMethod === 'DIGITAL'"
              class="text-purple-600 text-lg">account_balance_wallet</mat-icon>
            <span *ngIf="paymentMethod === 'CASH'" class="text-lg">💵</span>
            {{ paymentMethod === 'CARD' ? 'Credit Card' : paymentMethod === 'CASH' ? 'Cash' : 'Digital Payment'
            }}
          </span>
        </div>

        <div class="flex items-center justify-between">
          <span class="text-sm text-gray-600">Order Type:</span>
          <span class="text-sm font-semibold text-gray-800 flex items-center gap-2">
            <mat-icon class="text-orange-600 text-lg">{{ orderType === 'table' ? 'restaurant' : 'shopping_bag'
              }}</mat-icon>
            {{ orderType === 'table' ? 'Dine In - Table ' + tableNumber : 'Takeaway' }}
          </span>
        </div>

        <div *ngIf="customerName" class="flex items-center justify-between">
          <span class="text-sm text-gray-600">Customer:</span>
          <span class="text-sm font-semibold text-gray-800">{{ customerName }}</span>
        </div>
      </div>

      <!-- Confirmation Message -->
      <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-6">
        <div class="flex items-start gap-2">
          <mat-icon class="text-yellow-600 text-lg">info</mat-icon>
          <p class="text-xs text-yellow-800">
            <span *ngIf="paymentMethod === 'CASH'">
              By confirming, your order will be sent to the kitchen. You can pay at the counter.
            </span>
            <span *ngIf="paymentMethod !== 'CASH'">
              By confirming, you will be redirected to Stripe's secure payment page.
            </span>
          </p>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="space-y-3">
        <button mat-raised-button color="primary" (click)="confirmPayment()"
          class="w-full py-3 text-lg font-semibold shadow-lg hover:shadow-xl transition-shadow">
          <mat-icon class="mr-2">{{ paymentMethod === 'CASH' ? 'done' : 'lock' }}</mat-icon>
          {{ paymentMethod === 'CASH' ? 'Confirm Order' : 'Proceed to Payment' }}
        </button>

        <button mat-stroked-button (click)="cancelPaymentConfirmation()" class="w-full py-3 text-base">
          <mat-icon class="mr-2">arrow_back</mat-icon>
          Back
        </button>
      </div>

      <!-- Security Badge -->
      <div *ngIf="paymentMethod !== 'CASH'" class="mt-4 flex items-center justify-center gap-2 text-xs text-gray-500">
        <mat-icon class="text-green-600 text-sm">verified_user</mat-icon>
        <span>100% secure payment by Stripe</span>
      </div>
    </div>
  </mat-dialog-content>

  <app-footer></app-footer>

</div>

<!-- Rating prompt, shown once the order is in. Anonymous customers can use it
     too: the session feedback endpoint is public, which is the only way most
     of the traffic could ever leave a rating. -->
<div *ngIf="isFeedbackOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-6 w-full max-w-md mx-4">
    <h2 class="text-xl font-semibold mb-1">How was it?</h2>
    <p class="text-sm text-gray-500 mb-4">Your rating is shown to other customers choosing a bar.</p>

    <div class="flex justify-center gap-2 mb-4">
      <button mat-icon-button *ngFor="let star of [1,2,3,4,5]" (click)="setFeedbackRating(star)"
              [attr.aria-label]="star + ' star'">
        <mat-icon [class.text-yellow-400]="star <= feedbackRating"
                  [class.text-gray-300]="star > feedbackRating">
          {{ star <= feedbackRating ? 'star' : 'star_border' }}
        </mat-icon>
      </button>
    </div>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Anything you would like to add?</mat-label>
      <textarea matInput rows="3" [(ngModel)]="feedbackComment" placeholder="Optional"></textarea>
    </mat-form-field>

    <div class="flex gap-2 mt-2">
      <button mat-stroked-button (click)="dismissFeedback()" class="flex-1">Not now</button>
      <button mat-raised-button color="primary" (click)="submitFeedback()" class="flex-1"
              [disabled]="feedbackRating < 1">Send rating</button>
    </div>
  </div>
</div>
